import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { SelectModule } from "ng-select";
import { SharedService } from './services/shared.service'
import { ApplicationPipes } from './pipes/TimeFormatPipe';
import { ErrorsComponent } from './components/errors/errors.component';
import { LoaderComponent } from './components/loader/loader.component';
import { EmailSmsDataService } from './services/email-sms-data.service';
import { EmailSmsHelperUtils } from './services/email-sms-helper';
import { EmailSmsSubject } from './services/email-sms-subject';
import { QuizHelperUtil } from './services/QuizHelper.util';
import { SuggestionPanelComponent } from './components/suggestion-panel/suggestion-panel.component';
import { ShareConfigService } from './services/shareConfig.service';
import { ClickOutsideModule } from 'ng-click-outside';
import { TranslateModule } from "@ngx-translate/core";
import { FroalaEditorOptions } from './services/template-froala-options';
import { MediaLibraryComponent } from './components/media-library/media-library.component';
import { sanitizeUrlPipes } from './pipes/sanitizerUrl.pipe';
import { VariablePopupService } from './services/variable-popup.service';
import { AvailablestepsService } from './services/availablesteps.service';
import { MessageVariablesPopupComponent } from './components/message-variables-popup/message-variables-popup.component';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { WhatsappTemplateComponent } from '../appointments/appointment-types/add-appointment-type/messages/whatsapp-template/whatsapp-template.component';
import { SmsTemplateComponent } from '../appointments/appointment-types/add-appointment-type/messages/sms-template/sms-template.component';
import { LoaderSpinnerModule } from './loader-spinner';
import { SubjectTemplateComponent } from '../appointments/appointment-types/add-appointment-type/messages/subject-template/subject-template.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        ApplicationPipes,
        ClickOutsideModule,
        TranslateModule,
        sanitizeUrlPipes,
        FroalaEditorModule.forRoot(),
        FroalaViewModule.forRoot(),
        LoaderSpinnerModule
    ],
    declarations: [
        ErrorsComponent,
        LoaderComponent,
        SuggestionPanelComponent,
        MediaLibraryComponent,
        MessageVariablesPopupComponent,
        WhatsappTemplateComponent,
        SmsTemplateComponent,
        SubjectTemplateComponent
    ],
    providers:[
        SharedService, 
        EmailSmsDataService, 
        EmailSmsHelperUtils,
        EmailSmsSubject,
        QuizHelperUtil,
        ShareConfigService,
        FroalaEditorOptions,
        VariablePopupService,
        AvailablestepsService
    ],
    exports: [
        ApplicationPipes,
        SuggestionPanelComponent,
        MediaLibraryComponent,
        sanitizeUrlPipes,
        MessageVariablesPopupComponent,
        WhatsappTemplateComponent,
        SmsTemplateComponent,
        SubjectTemplateComponent
    ]
})
export class SharedModule {
}


// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts